import { Injectable } from '@angular/core';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { LoggerService } from './logger.service';
import { PrefsService } from './prefs.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class PersonsService {
  randomNumber: number; // same for all Persons members
  deviceOwner: any;
  nonParticipants: any;

  constructor(
    private logger: LoggerService,
    private prefs: PrefsService,
    private utils: UtilsService
  ) {
    this.logger.log('Persons constructor', MSRemoteLoggerCategory.PERSONS_SERVICE);
  }

  populated() {
    return new Promise((resolve, reject) => {
      this.prefs
        .getPromise('persons')
        .then((res) => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  populate(data) {
    // add in-app properties
    data.persons.forEach((p) => (p.daysWithClickedPrompt = ''));
    return this.prefs.getStorePromise('persons', data.persons);
  }

  setAll(data) {
    return this.prefs.getStorePromise('persons', data);
  }

  getAll() {
    return this.prefs.getPromiseOrDefault('persons');
  }

  getDeviceOwner() {
    // TODO - fix idx
    return this.prefs.getPromises('personId', 'persons').then((results) => {
      const persons = Array.prototype.slice.call(results[1]);
      return persons.filter((person) => person.idx === results[0])[0];
    });
  }

  setDeviceOwner(id) {
    return this.prefs
      .getStorePromise('personId', id)
      .then(() => this.getDeviceOwner())
      .then((res) => {
        this.deviceOwner = res;
      });
  }

  getParticipants() {
    return this.prefs
      .getPromise('persons')
      .then((res) => {
        const persons = Array.prototype.slice.call(res);
        return persons.filter((person) => person.participant === true);
      })
      .catch((err) => []);
  }

  getNonParticipants() {
    return this.prefs
      .getPromise('persons')
      .then((res) => {
        const persons = Array.prototype.slice.call(res);
        return persons.filter((person) => person.participant === false);
      })
      .catch((err) => []);
  }

  getSurveyable() {
    return this.prefs
      .getPromise('persons')
      .then((res) => {
        const persons = Array.prototype.slice.call(res);
        return persons.filter((person) => person.surveyable === true);
      })
      .catch((err) => []);
  }

  getSurveyableParticipants() {
    return this.prefs
      .getPromise('persons')
      .then((res) => {
        const persons = Array.prototype.slice.call(res);
        return persons.filter((person) => person.participant === true && person.surveyable === true);
      })
      .catch((err) => []);
  }

  getSurveyableNonParticipants() {
    return this.prefs
      .getPromise('persons')
      .then((res) => {
        const persons = Array.prototype.slice.call(res);
        return persons.filter((person) => person.participant === false && person.surveyable === true);
      })
      .catch((err) => []);
  }

  getPersonById(id) {
    return this.prefs
      .getPromise('persons')
      .then((res) => {
        const persons = Array.prototype.slice.call(res);
        return persons.filter((person) => person.idx === id)[0];
      })
      .catch((err) => null);
  }

  setRandom() {
    const self = this;
    return this.prefs.getPromise('authCode').then((authCode) => {
      self.randomNumber = self.utils.randomFromString(authCode);
      self.logger.log('Set household random to ', MSRemoteLoggerCategory.PERSONS_SERVICE, self.randomNumber, 'for', authCode as string);
    });
  }

  getRandom() {
    return this.randomNumber;
  }

  getAllForDashboard() {
    return Promise.all([this.getDeviceOwner(), this.getSurveyableNonParticipants()]).then((res) => {
      if (res[0].is_proxy === true) {
        return [res[0]].concat(res[1]);
      } else {
        return [res[0]];
      }
    });
  }

  initialize() {
    // TODO - is it better to store these fields on initialization or to pull from prefs every time?
    return Promise.all([this.getDeviceOwner(), this.getNonParticipants(), this.setRandom()]).then((res) => {
      this.deviceOwner = res[0];
      this.nonParticipants = res[1];
    });

    //return this.setRandom();
  }
}
